<style src="./Logo.scss" lang="scss"></style>

<template lang="pug">
  router-link.logo(
    to='/'
  )
    img.logo__img(:src="image")
</template>

<script>
import axios from "axios";
import { API_URL, HOST_URL } from "@/constants";
export default {
  data() {
    return {
      image: ""
    };
  },
  mounted() {
    axios.get(`${API_URL}/logo`).then(response => {
      this.image = HOST_URL + response.data.payload.logoUrl;
    });
  }
};
</script>
